<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12" v-for="organization in organizations" :key="organization.id">
        <Organization :organization="organization" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Organization from './Organization.vue'

  export default {
    name: 'OrganizationList',

    components: {
      Organization
    },

    data: () => ({
      organizations: [
        {
          id: 'org1',
          name: 'Freedom Fund',
          logoUrl: ''
        },
        {
          id: 'org2',
          name: 'Safe Kids Worldwide',
          logoUrl: ''
        },
        {
          id: 'org3',
          name: 'The Impact Foundry',
          logoUrl: ''
        },
      ]
    })
  }
</script>
